/* Copyright 2022- Martin Kufner */
Reflect.defineProperty(Boolean, "parse", {
    value(v) { return typeof v === 'string' ? /\bt(rue)?\b/.test(v) : v; }
})